
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-lock" })
export default class IconLock extends Vue {
  sData: string = require("@icon/feather/lock.svg");
}
